import _ from "lodash"
import { emptyPromise, handleGeneralXhrError } from "../helpers"

const PropertySyncMixin = {
	methods: {
        syncToPropWithAjax(value, property, url, propertyAttribute = 'id') {
            if (value == _.get(this, `${property}.${propertyAttribute}`, null)) {
                return emptyPromise()
            }

            if (!value) {
                _.set(this, property, null)
                return emptyPromise()
            }

            if (hasLoading(this)) {
                this.isLoading = true
            }

            const request = axios.get(url)
                .then(response => {
                    _.set(this, property, response.data.data)
                })
            return handleGeneralXhrError(request).finally(() => {
                if (hasLoading(this)) {
                    this.isLoading = false
                }
            })
        },
        syncToProp(value, property) {
            if (_.get(this, property) == value) {
                return
            }
            _.set(this, property, value)
        },
	}
}

function hasLoading(obj) {
    return typeof obj.isLoading !== 'undefined'
}

export default PropertySyncMixin
